module.exports = __webpack_public_path__ + "media/src/public/images/logo-and-name-dark-f2f4877758daf6a7e668430d0ce41d69.svg";